import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

const mediaDomain = process.env.REACT_APP_MEDIA_DOMAIN;

export function postAgent16(params) {
  return authPost(`${baseUrl}/Agent16.ashx`, params);
}

export function createPost(params) {
  return authFormPost(
    `${window.location.protocol}//${mediaDomain}/api/createPost.php`,
    params
  );
}

export function createComment(params) {
  return authFormPost(
    `${window.location.protocol}//${mediaDomain}/api/createComment.php`,
    params
  );
}
